export default __webpack_public_path__ + "static/project-slide-7-415-700-b2525f979d2435f763005827640be8db.jpg";